import { COLLECTION_VIEW_QP_KEYS } from 'volta/components/collection-view/api';
import { DEFAULT_FILTERS_SEPARATOR, inFilter } from 'volta/utils/filters-utils';

import { action } from '@ember/object';

import WidgetReports from '../planning-report';

export default class PlanningKpisWidget extends WidgetReports {
  @action
  transitionToFilteredAlerts(zoneType: string, priority: string) {
    const queryParams = this.buildPlanningExecQueryParams();

    const buildFilters = (zoneType: string, priority: string) =>
      zoneType + DEFAULT_FILTERS_SEPARATOR + inFilter([priority]);

    if (priority && zoneType) {
      switch (priority) {
        case 'critical':
          queryParams.filters = buildFilters(zoneType, '0');
          break;
        case 'high':
          queryParams.filters = buildFilters(zoneType, '1');
          break;
        case 'medium':
          queryParams.filters = buildFilters(zoneType, '2');
          break;
        case 'low':
          queryParams.filters = buildFilters(zoneType, '3');
          break;
        case 'otog':
          queryParams.filters = buildFilters(zoneType, '4');
          break;
      }
    }

    if (zoneType === 'timeBuffer') {
      queryParams.sortBy = 'sku.task';
    }

    this.router.transitionTo('protected.alerts', { queryParams });
  }

  @action
  transitionToFilteredPlannings(priority?: string) {
    const queryParams = this.buildPlanningExecQueryParams();

    if (priority) {
      switch (priority) {
        case 'critical':
          queryParams.bufferZone = inFilter(['0']);
          break;
        case 'high':
          queryParams.bufferZone = inFilter(['1']);
          break;
        case 'medium':
          queryParams.bufferZone = inFilter(['2']);
          break;
        case 'low':
          queryParams.bufferZone = inFilter(['3']);
          break;
        case 'otog':
          queryParams.bufferZone = inFilter(['4']);
          break;
      }
    }

    this.router.transitionTo('protected.plannings', { queryParams });
  }

  private buildPlanningExecQueryParams(): TQueryParams {
    const queryParams: TQueryParams = {};

    // Reset plannings page route sticky parameters
    [
      'sort',
      'pageSize',
      'bufferZone',
      'q',
      'buyer',
      'reorderQty',
      'status',
      'methodology',
      'ohaZone',
      'projectedOhaZone',
      'demand'
    ]
      .concat(COLLECTION_VIEW_QP_KEYS)
      .forEach((key) => {
        queryParams[key] = undefined;
      });

    return {
      ...queryParams,
      ...this.args.queryParamsValues
    };
  }
}
